/* Frantoio di Assisi — comportamenti del tema (vanilla JS, nessuna dipendenza).
   Ogni modulo si attiva da attributi data-fa-* e si re-inizializza quando una sezione
   viene modificata nell'editor del tema (eventi shopify:section:load). */
(function () {
  'use strict';
  var FA = window.FA || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    try { return new Intl.NumberFormat(FA.locale || 'it', { style: 'currency', currency: FA.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function toast(msg) {
    var t = document.querySelector('[data-fa-toast]');
    if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }

  /* Reveal allo scroll */
  function initReveal(root) {
    var els = $all('.fa-reveal, .fa-grow', root);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Barra annunci a rotazione */
  function initAnnouncement(root) {
    $all('[data-fa-announcement]', root).forEach(function (el) {
      var msgs = $all('.fa-announcement__msg', el); if (msgs.length < 2 || reduce) return;
      var i = 0; clearInterval(el._t);
      el._t = setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, (parseInt(el.dataset.speed, 10) || 5) * 1000);
    });
  }

  /* Header mobile */
  function initHeader(root) {
    $all('[data-fa-menu-toggle]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var h = btn.closest('.fa-header'); var open = h.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Slideshow */
  function initSlideshow(root) {
    $all('[data-fa-slideshow]', root).forEach(function (el) {
      var slides = $all('[data-fa-slide]', el), dots = $all('[data-fa-dot]', el), pause = el.querySelector('[data-fa-pause]');
      if (!slides.length) return;
      function hydrate() { $all('template[data-fa-defer]', el).forEach(function (t) { t.parentNode.insertBefore(t.content.cloneNode(true), t); t.remove(); }); }
      if (document.readyState === 'complete') setTimeout(hydrate, 1500); else window.addEventListener('load', function () { setTimeout(hydrate, 1500); });
      var secs = parseInt(el.dataset.autoplay, 10) || 7, i = 0, playing = !reduce, hover = false;
      el.style.setProperty('--dur', secs + 's');
      function go(n) {
        hydrate();
        slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true'); if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].removeAttribute('aria-current'); }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden'); if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
      }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); restart(); }); });
      function restart() { clearInterval(el._t); if (playing && slides.length > 1) el._t = setInterval(function () { if (!hover) go(i + 1); }, secs * 1000); }
      el.addEventListener('mouseenter', function () { hover = true; el.classList.add('is-paused'); });
      el.addEventListener('mouseleave', function () { hover = false; if (playing) el.classList.remove('is-paused'); });
      if (pause) pause.addEventListener('click', function () {
        playing = !playing; el.classList.toggle('is-paused', !playing);
        pause.setAttribute('aria-label', playing ? pause.dataset.labelPause : pause.dataset.labelPlay);
        pause.classList.toggle('is-playing', playing); restart();
      });
      if (!playing) el.classList.add('is-paused');
      restart();
    });
  }

  /* Carousel orizzontale */
  function initCarousel(root) {
    $all('[data-fa-carousel]', root).forEach(function (el) {
      var track = el.querySelector('[data-fa-track]'); if (!track) return;
      var step = function (d) { track.scrollBy({ left: d * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); };
      var p = el.querySelector('[data-fa-prev]'), n = el.querySelector('[data-fa-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  /* Tabs accessibili */
  function initTabs(root) {
    $all('[data-fa-tabs]', root).forEach(function (el) {
      var tabs = $all('[role="tab"]', el);
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) { if (on) { p.hidden = false; p.classList.remove('fa-panel-in'); void p.offsetWidth; p.classList.add('fa-panel-in'); } else { p.hidden = true; } }
        });
      }
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, d = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 0;
          if (d) { e.preventDefault(); var nt = tabs[(n + d + tabs.length) % tabs.length]; nt.focus(); select(nt); }
        });
      });
      $all('[data-fa-tab-step]', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var cur = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
          select(tabs[(cur + parseInt(b.dataset.faTabStep, 10) + tabs.length) % tabs.length]);
        });
      });
    });
  }

  /* Filtri a chip lato client */
  function initFilter(root) {
    $all('[data-fa-filter]', root).forEach(function (el) {
      var btns = $all('[data-fa-filter-btn]', el), items = $all('[data-fa-filter-item]', el), count = el.querySelector('[data-fa-filter-count]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.dataset.faFilterBtn, shown = 0;
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          items.forEach(function (it) {
            var ok = v === 'all' || (' ' + it.dataset.faFilterItem + ' ').indexOf(' ' + v + ' ') > -1;
            it.hidden = !ok; if (ok) shown++;
          });
          if (count) count.textContent = shown;
        });
      });
    });
  }

  /* Quiz vero/falso */
  function initQuiz(root) {
    $all('[data-fa-quiz]', root).forEach(function (el) {
      var items = $all('[data-fa-quiz-item]', el), score = el.querySelector('[data-fa-quiz-score]'), bar = el.querySelector('[data-fa-quiz-bar]'),
          total = el.querySelector('[data-fa-quiz-total]'), msg = el.querySelector('[data-fa-quiz-msg]'), reset = el.querySelector('[data-fa-quiz-reset]');
      if (total) total.textContent = items.length;
      function update() {
        var answered = 0, right = 0;
        items.forEach(function (it) { if (it.dataset.picked) { answered++; if (it.dataset.picked === it.dataset.answer) right++; } });
        if (score) score.textContent = right;
        if (bar) bar.style.setProperty('--v', Math.round(answered / items.length * 100) + '%');
        if (msg) {
          if (!answered) msg.textContent = msg.dataset.start || '';
          else if (answered < items.length) msg.textContent = (msg.dataset.more || '').replace('[n]', items.length - answered);
          else msg.textContent = right >= items.length * 0.8 ? (msg.dataset.great || '') : right >= items.length * 0.5 ? (msg.dataset.good || '') : (msg.dataset.ok || '');
        }
      }
      items.forEach(function (it) {
        $all('[data-fa-quiz-pick]', it).forEach(function (b) {
          b.addEventListener('click', function () {
            it.dataset.picked = b.dataset.faQuizPick;
            it.classList.add('is-answered'); it.classList.toggle('is-right', it.dataset.picked === it.dataset.answer);
            $all('[data-fa-quiz-pick]', it).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            var ans = it.querySelector('[data-fa-quiz-answer]'); if (ans) { ans.hidden = false; }
            var res = it.querySelector('[data-fa-quiz-result]'); if (res) res.textContent = it.dataset.picked === it.dataset.answer ? res.dataset.right : res.dataset.wrong;
            update();
          });
        });
      });
      if (reset) reset.addEventListener('click', function () {
        items.forEach(function (it) { delete it.dataset.picked; it.classList.remove('is-answered', 'is-right'); var a = it.querySelector('[data-fa-quiz-answer]'); if (a) a.hidden = true; $all('[data-fa-quiz-pick]', it).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); });
        update();
      });
      update();
    });
  }

  /* Dosi ricetta */
  function initScaler(root) {
    $all('[data-fa-scaler]', root).forEach(function (el) {
      var out = el.querySelector('[data-fa-servings]'); if (!out) return;
      var base = parseInt(el.dataset.base, 10) || 4, n = base;
      function fmt(v) { var r = v >= 10 ? Math.round(v / 5) * 5 : Math.round(v * 2) / 2; return String(r).replace('.', ','); }
      function render() {
        out.textContent = n;
        $all('[data-fa-qty]', el).forEach(function (q) { var b = parseFloat(q.dataset.base); if (!isNaN(b)) q.textContent = fmt(b * n / base) + (q.dataset.unit ? ' ' + q.dataset.unit : ''); });
      }
      var m = el.querySelector('[data-fa-servings-minus]'), p = el.querySelector('[data-fa-servings-plus]');
      if (m) m.addEventListener('click', function () { n = Math.max(1, n - 1); render(); });
      if (p) p.addEventListener('click', function () { n = Math.min(24, n + 1); render(); });
      $all('[data-fa-check]', el).forEach(function (c) { c.addEventListener('change', function () { c.closest('label').classList.toggle('is-done', c.checked); }); });
    });
  }

  /* Scorta e abbonamento: formato → taglio (1/3/6) oppure abbonamento */
  function initModes(root) {
    $all('[data-fa-stock]', root).forEach(function (form) {
      var d3 = parseFloat(form.dataset.d3) || 0, d6 = parseFloat(form.dataset.d6) || 0, subDisc = parseFloat(form.dataset.subDisc) || 0;
      var qtyInput = form.querySelector('[data-fa-stock-qty]'), planInput = form.querySelector('[data-fa-stock-plan]');
      var breaks = $all('[data-fa-break]', form), plans = $all('[data-fa-plan]', form), modes = $all('[data-fa-stock-mode]', form);
      var totalEl = form.querySelector('[data-fa-stock-total]'), saveEl = form.querySelector('[data-fa-stock-save]'), cta = form.querySelector('[data-fa-stock-cta]');
      var noPlan = form.querySelector('[data-fa-stock-noplan]');
      var mode = 'once', qty = 3, plan = null;
      function variant() { return form.querySelector('input[name="id"]:checked'); }
      function render() {
        var v = variant(); if (!v) return;
        var price = parseInt(v.dataset.price, 10) || 0;
        breaks.forEach(function (o) {
          var q = parseInt(o.dataset.qty, 10), d = parseFloat(o.dataset.discount) || 0;
          var el = o.querySelector('[data-fa-break-price]'); if (el) el.textContent = money(Math.round(price * q * (1 - d / 100)));
          o.setAttribute('aria-checked', q === qty ? 'true' : 'false');
        });
        var allowed = (v.dataset.plans || '').split(',').filter(Boolean);
        plans.forEach(function (b) { var ok = allowed.indexOf(b.dataset.faPlan) > -1; b.disabled = !ok; b.hidden = !ok; });
        if (plan && allowed.indexOf(plan) < 0) plan = null;
        if (!plan && allowed.length) plan = allowed[0];
        plans.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.faPlan === plan ? 'true' : 'false'); });
        if (noPlan) noPlan.hidden = !(mode === 'sub' && !allowed.length);
        $all('[data-fa-stock-panel]', form).forEach(function (p) { p.hidden = p.dataset.faStockPanel !== mode; });
        modes.forEach(function (m) { m.setAttribute('aria-selected', m.dataset.faStockMode === mode ? 'true' : 'false'); });
        if (mode === 'once') {
          var d = qty === 3 ? d3 : qty === 6 ? d6 : 0, tot = Math.round(price * qty * (1 - d / 100));
          qtyInput.value = qty; planInput.disabled = true; planInput.value = '';
          if (totalEl) totalEl.textContent = money(tot);
          if (saveEl) saveEl.textContent = d ? (saveEl.dataset.save || '').replace('[s]', money(price * qty - tot)) : '';
          if (cta) { cta.textContent = (cta.dataset.label || '').replace('[q]', qty); cta.disabled = false; }
        } else {
          var sp = parseInt(v.dataset.subPrice, 10); if (isNaN(sp)) sp = Math.round(price * (1 - subDisc / 100));
          qtyInput.value = 1; planInput.disabled = !plan; planInput.value = plan || '';
          if (totalEl) totalEl.textContent = allowed.length ? money(sp) : '';
          if (saveEl) saveEl.textContent = allowed.length ? (saveEl.dataset.sub || '') : '';
          if (cta) { cta.textContent = cta.dataset.labelSub || ''; cta.disabled = !plan; }
        }
      }
      $all('input[name="id"]', form).forEach(function (r) { r.addEventListener('change', render); });
      breaks.forEach(function (o) { o.addEventListener('click', function () { qty = parseInt(o.dataset.qty, 10); render(); }); });
      plans.forEach(function (b) { b.addEventListener('click', function () { plan = b.dataset.faPlan; render(); }); });
      modes.forEach(function (m) { m.addEventListener('click', function () {
        mode = m.dataset.faStockMode;
        var v = variant();
        if (mode === 'sub' && v && !v.dataset.plans) { var alt = $all('input[name="id"]', form).find(function (r) { return r.dataset.plans; }); if (alt) alt.checked = true; }
        form.classList.toggle('is-sub', mode === 'sub'); render();
      }); });
      render();
    });
  }

  /* Selettore varianti nella scheda prodotto */
  function initVariantPicker(root) {
    $all('[data-fa-product]', root).forEach(function (el) {
      var dataEl = el.querySelector('[data-fa-variants]'); if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent || '[]');
      var idInput = el.querySelector('input[name="id"]'), priceEl = el.querySelector('[data-fa-price]'), unitEl = el.querySelector('[data-fa-unit]'),
          stockEl = el.querySelector('[data-fa-stock]'), atc = $all('[data-fa-atc]', document), labelEls = $all('[data-fa-variant-label]', document);
      function selected() {
        var vals = $all('[data-fa-option]', el).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); });
      }
      function update() {
        var v = selected(); if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
        if (unitEl) unitEl.textContent = v.unit || '';
        if (stockEl) stockEl.textContent = v.available ? stockEl.dataset.in : stockEl.dataset.out;
        atc.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? FA.strings.addToCart : FA.strings.soldOut; });
        labelEls.forEach(function (l) { l.textContent = v.title; });
        // Galleria: mostra le immagini della variante (campo "galleria" o immagine principale)
        var gal = el.querySelector('[data-fa-gallery]');
        if (gal) {
          var ids = (v.media || []).map(String);
          var thumbs = $all('[data-fa-media]', gal), shown = 0;
          thumbs.forEach(function (t) {
            var mine = !ids.length || ids.indexOf(t.dataset.faMedia) > -1 || t.dataset.shared === 'true';
            t.hidden = !mine; if (mine) shown++;
          });
          var firstId = ids[0]; var main = firstId ? gal.querySelector('[data-fa-media="' + firstId + '"]') : null;
          if (main) setMain(gal, main);
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      $all('[data-fa-option] input', el).forEach(function (i) { i.addEventListener('change', update); });
      update();
    });
    $all('[data-fa-gallery]', root).forEach(function (gal) {
      $all('[data-fa-media]', gal).forEach(function (t) { t.addEventListener('click', function () { setMain(gal, t); }); });
    });
  }
  function setMain(gal, thumb) {
    var main = gal.querySelector('[data-fa-main]'); if (!main) return;
    var img = thumb.querySelector('img'); if (!img) return;
    var mi = main.querySelector('img'); if (!mi) return;
    mi.src = img.dataset.large || img.src; mi.srcset = img.dataset.srcset || ''; mi.alt = img.alt;
    $all('[data-fa-media]', gal).forEach(function (x) { x.setAttribute('aria-pressed', x === thumb ? 'true' : 'false'); });
  }

  /* Barra d'acquisto fissa */
  function initStickyAtc(root) {
    $all('[data-fa-sticky-atc]', root).forEach(function (bar) {
      var target = document.querySelector(bar.dataset.faStickyAtc || '[data-fa-product]'); if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(target);
    });
  }

  /* Carrello laterale */
  var drawer, scrim;
  function openCart() { if (!drawer) return; drawer.classList.add('is-open'); scrim.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); var c = drawer.querySelector('[data-fa-cart-close]'); if (c) c.focus(); }
  function closeCart() { if (!drawer) return; drawer.classList.remove('is-open'); scrim.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  function refreshCart() {
    return fetch((FA.routes.root || '/') + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-fa-drawer-inner]'), cur = document.querySelector('[data-fa-drawer-inner]');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; bindCartLines(); }
      var countEl = doc.querySelector('[data-fa-cart-count-value]');
      if (countEl) $all('[data-fa-cart-count]').forEach(function (c) { c.textContent = countEl.dataset.faCartCountValue; });
    });
  }
  function bindCartLines() {
    $all('[data-fa-line-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        fetch(FA.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.faLineQty, 10) }) }).then(refreshCart);
      });
    });
  }
  function initCart() {
    drawer = document.querySelector('[data-fa-drawer]'); scrim = document.querySelector('[data-fa-scrim]');
    $all('[data-fa-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openCart(); } }); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-fa-cart-close]') || e.target.matches('[data-fa-scrim]')) closeCart(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    bindCartLines();
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-fa-add-to-cart]'); if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      fetch(FA.routes.cart_add + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (res) { if (res.status) { toast(res.description || res.message); return; } toast(FA.strings.added + ' ' + (res.product_title || '')); return refreshCart().then(openCart); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  function init(root) {
    initReveal(root); initAnnouncement(root); initHeader(root); initSlideshow(root); initCarousel(root); initTabs(root);
    initFilter(root); initQuiz(root); initScaler(root); initModes(root); initVariantPicker(root); initStickyAtc(root);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); initCart(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
